// extracted by mini-css-extract-plugin
export default {"common_select":"infinite-select_common_select__mx3YP","flat_select":"infinite-select_flat_select__dvhbw"};